<i18n>
{
	"en": {
		"createNewLeg": "New leg"
	},
	"no": {
		"createNewLeg": "Ny leg"
	}
}
</i18n>

<template>
	<div>
		<transition-group name="fade" tag="div">
			<Leg
				v-for="leg in trip.legs"
				:key="leg.id"
				:leg="leg"
				:numOfLegs="trip.legs.length"
			/>
		</transition-group>
		<t-button iconBefore="add" appearance="minimal" @click="addLeg">{{$t('createNewLeg')}}</t-button>
	</div>
</template>

<script>
import Leg from './Leg.vue';
import { mapState, mapActions } from '../store/newTrip.store.js';
export default {
	name: 'Legs',
	components: { Leg, },
	computed: { ...mapState(['trip',]), },
	methods: { ...mapActions(['addLeg']), },
};
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .2s ease;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>
